


// import React, { useEffect } from 'react';
// import styled from 'styled-components';
// import IRDLabel from '../components/IRDLabel';

// const Wrapper = styled.div`
//   width: 100%;
//   min-height: 120vh;
//   padding: 10vh 5vw 5vh 5vw;
//   margin-top: 5vh;
// `;

// const HeadDiv = styled.div`
//   width: 100%;
//   background-color: var(--secondary);
//   color: #ffffff;
//   border-radius: 15px;
//   padding: 6vh 4vw 4vh 4vw;
//   position: relative;
// `;

// const NameDiv = styled.div`
//   position: absolute;
//   top: -4vh;
//   left: 3vw;
//   background-color: var(--primary);
//   border-radius: 15px;
//   padding: 1vh 1vw;
// `;

// const Title = styled.h1`
//   font-size: 2.8em;
//   font-weight: 600;
//   color: #2C2E35;

//   @media(max-width:768px){
//     font-size: 2em;
//   }
// `;

// const Details = styled.div`
//   margin-top: 2vh;
//   font-size: 1.1rem;
//   line-height: 1.6;
//   color: #ffffff;

//   @media(max-width:768px){
//     font-size: 0.95rem;
//   }

//   p{
//     margin: 1rem 0;
//   }

//   ul{
//     margin: 0.5rem 0 1rem 1.8rem;
//   }

//   li{
//     margin-bottom: 0.5rem;
//   }
// `;

// const AdjectiveDiv = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: space-around;
//   align-items: center;
//   padding: 4vh 0;
//   gap: 2vw;

//   @media(max-width:768px){
//     flex-wrap: wrap;
//     gap: 2vh;
//   }
// `;

// const Adjective = styled.span`
//   font-size: 1.9em;
//   font-weight: 800;
//   opacity: 0.7;
//   color: var(--secondary);

//   @media(max-width:768px){
//     font-size: 1.3em;
//   }
// `;

// const SmCircle = styled.div`
//   background-color: var(--primary);
//   opacity: 0.6;
//   width: 2em;
//   height: 2em;
//   border-radius: 50%;

//   @media(max-width:768px){
//     width: 1em;
//     height: 1em;
//   }
// `;

// const ContentWrapper = styled.div`
//   display: flex;
//   gap: 4vw;
//   align-items: flex-start;
//   flex-wrap: wrap;
//   margin-top: 4vh;

//   @media(max-width:768px){
//     flex-direction: column;
//     gap: 4vh;
//   }
// `;

// const Img = styled.img`
//   flex: 1 1 42%;
//   max-width: 42vw;
//   height: auto;
//   object-fit: contain;

//   @media(max-width:1050px){
//     max-width: 55vw;
//   }

//   @media(max-width:768px){
//     width: 90%;
//     margin: 0 auto;
//   }
// `;

// const TextDiv = styled.div`
//   flex: 1 1 55%;
//   max-width: 600px;
//   font-size: 16px;
//   line-height: 1.6;
//   color: #333;

//   @media(max-width:1050px){
//     max-width: 450px;
//   }

//   @media(max-width:768px){
//     width: 90%;
//     margin: 0 auto;
//     font-size: 14px;
//   }

//   h3 {
//     color: var(--secondary);
//     margin-bottom: 1vh;
//   }

//   ul {
//     padding-left: 1.5rem;
//     margin-bottom: 1.5vh;
//   }

//   li {
//     margin-bottom: 0.8rem;
//   }
// `;

// const IRDSSpecsEnvironmental = () => {
//   useEffect(() => {
//     window.scrollTo(0,0);
//   }, []);

//   return (
//     <Wrapper>
   
//       <HeadDiv>
//         <NameDiv>
//           <Title>IMPACT Integrated Rock Drill & Splitter</Title>
//         </NameDiv>
//         <Details>
//           <p><strong>An Advanced Non-Blasting Rock-Breaking Equipment</strong></p>
//           <p>
//             Integrated hydraulic rock drill and splitter is an advanced non-blasting rock-breaking equipment that can break very hard rocks.
//             The rock drill and splitter are perfectly combined with the excavator, and the corresponding electro-hydraulic control system is added by using the original power of the excavator, realizing a multi-purpose machine.
//           </p>
//           <p>
//             Integrated hydraulic rock drill and splitter have fast drilling speed, large splitting force, and flexible movement of the whole machine.
//             It can work on any working face from various angles and can effectively cope with various complex construction environments.
//           </p>
//         </Details>
//       </HeadDiv>

//       <IRDLabel />

    
//       <AdjectiveDiv>
//         <Adjective>POWERFUL</Adjective>
//         <SmCircle/>
//         <Adjective>PRECISE</Adjective>
//         <SmCircle/>
//         <Adjective>EFFICIENT</Adjective>
//         <SmCircle/>
//         <Adjective>SAFE</Adjective>
//       </AdjectiveDiv>

   
//       <ContentWrapper>
//         <Img src="/images/s1.jpeg" alt="Integrated Rock Drill & Splitter" />
//         <TextDiv>
//           <h3>IRDSM - Environmental Benefits</h3>
//           <ul>
//             <li><strong>Eliminates the need for explosives:</strong> No blasting means no toxic gases, explosive residues, or chemical contamination of soil and water — reducing environmental hazards.</li>
//             <li><strong>Reduces dust generation:</strong> Controlled mechanical splitting produces far less airborne dust than blasting, improving air quality for workers and nearby communities.</li>
//             <li><strong>Minimizes ground vibration:</strong> Vibrations transmitted to the surrounding environment are significantly lower, protecting ecosystems, infrastructure, and geological stability.</li>
//             <li><strong>Lowers noise pollution:</strong> Hydraulic splitting operates with much lower noise levels compared to blasting, suitable near urban areas or sensitive habitats.</li>
//             <li><strong>Preserves surrounding ecosystems:</strong> Reduced shock waves, debris scatter, and vibration help maintain ecological balance around mining sites.</li>
//             <li><strong>Better control over fragmentation:</strong> Precision rock breakage reduces over-break and unnecessary waste, lowering energy and processing requirements.</li>
//             <li><strong>Supports compliance with stricter regulations:</strong> Reduced emissions, lower noise, and minimal vibration help meet environmental and community impact standards.</li>
//             <li><strong>Less Environmental Damage:</strong> Prevents damage to nearby structures, slopes, or ecosystems, safe for residential or protected areas.</li>
//             <li><strong>Lower Carbon Footprint:</strong> One machine instead of multiple → less fuel consumption, no explosives production or transport emissions.</li>
//           </ul>
//         </TextDiv>
//       </ContentWrapper>
//     </Wrapper>
//   );
// };

// export default IRDSSpecsEnvironmental;

import React, { useEffect } from 'react';
import styled from 'styled-components';
import IRDLabel from '../components/IRDLabel';

const Wrapper = styled.div`
  width: 100%;
  min-height: 120vh;
  padding: 10vh 5vw 5vh 5vw;
  margin-top: 5vh;
`;

const HeadDiv = styled.div`
  width: 100%;
  background-color: var(--secondary);
  color: #ffffff;
  border-radius: 15px;
  padding: 6vh 4vw 4vh 4vw;
  position: relative;
`;

const NameDiv = styled.div`
  position: absolute;
  top: -4vh;
  left: 3vw;
  background-color: var(--primary);
  border-radius: 15px;
  padding: 1vh 1vw;
`;

const Title = styled.h1`
  font-size: 2.8em;
  font-weight: 600;
  color: #2C2E35;

  @media(max-width:768px){
    font-size: 2em;
  }
`;

const Details = styled.div`
  margin-top: 2vh;
  font-size: 1.1rem;
  line-height: 1.6;
  color: #ffffff;

  @media(max-width:768px){
    font-size: 0.95rem;
  }

  p{
    margin: 1rem 0;
  }

  ul{
    margin: 0.5rem 0 1rem 1.8rem;
  }

  li{
    margin-bottom: 0.5rem;
  }
`;

/* FIXED SECTION */

const AdjectiveDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 2.5rem;
  padding: 4vh 0;

  @media(max-width:768px){
    gap: 1.5rem;
  }
`;

const AdjectiveGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Adjective = styled.span`
  font-size: 1.9em;
  font-weight: 800;
  opacity: 0.7;
  color: var(--secondary);
  letter-spacing: 1px;

  @media(max-width:768px){
    font-size: 1.3em;
  }
`;

const SmCircle = styled.div`
  background-color: var(--primary);
  opacity: 0.6;
  width: 14px;
  height: 14px;
  border-radius: 50%;

  @media(max-width:768px){
    width: 10px;
    height: 10px;
  }
`;

/* CONTENT SECTION */

const ContentWrapper = styled.div`
  display: flex;
  gap: 4vw;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 4vh;

  @media(max-width:768px){
    flex-direction: column;
    gap: 4vh;
  }
`;

const Img = styled.img`
  flex: 1 1 42%;
  max-width: 42vw;
  height: auto;
  object-fit: contain;

  @media(max-width:1050px){
    max-width: 55vw;
  }

  @media(max-width:768px){
    width: 90%;
    margin: 0 auto;
  }
`;

const TextDiv = styled.div`
  flex: 1 1 55%;
  max-width: 600px;
  font-size: 16px;
  line-height: 1.6;
  color: #333;

  @media(max-width:1050px){
    max-width: 450px;
  }

  @media(max-width:768px){
    width: 90%;
    margin: 0 auto;
    font-size: 14px;
  }

  h3 {
    color: var(--secondary);
    margin-bottom: 1vh;
  }

  ul {
    padding-left: 1.5rem;
    margin-bottom: 1.5vh;
  }

  li {
    margin-bottom: 0.8rem;
  }
`;

const IRDSSpecsEnvironmental = () => {

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  return (
    <Wrapper>

      <HeadDiv>
        <NameDiv>
          <Title>IMPACT Integrated Rock Drill & Splitter</Title>
        </NameDiv>

        <Details>
          <p><strong>An Advanced Non-Blasting Rock-Breaking Equipment</strong></p>

          <p>
            Integrated hydraulic rock drill and splitter is an advanced non-blasting rock-breaking equipment that can break very hard rocks.
            The rock drill and splitter are perfectly combined with the excavator, and the corresponding electro-hydraulic control system is added by using the original power of the excavator, realizing a multi-purpose machine.
          </p>

          <p>
            Integrated hydraulic rock drill and splitter have fast drilling speed, large splitting force, and flexible movement of the whole machine.
            It can work on any working face from various angles and can effectively cope with various complex construction environments.
          </p>
        </Details>
      </HeadDiv>

      <IRDLabel />

      {/* FIXED ADJECTIVE SECTION */}

      <AdjectiveDiv>

        <AdjectiveGroup>
          <Adjective>POWERFUL</Adjective>
          <SmCircle/>
        </AdjectiveGroup>

        <AdjectiveGroup>
          <Adjective>PRECISE</Adjective>
          <SmCircle/>
        </AdjectiveGroup>

        <AdjectiveGroup>
          <Adjective>EFFICIENT</Adjective>
          <SmCircle/>
        </AdjectiveGroup>

        <AdjectiveGroup>
          <Adjective>SAFE</Adjective>
        </AdjectiveGroup>

      </AdjectiveDiv>

      <ContentWrapper>

        <Img src="/images/s1.jpeg" alt="Integrated Rock Drill & Splitter" />

        <TextDiv>
          <h3>IRDSM - Environmental Benefits</h3>

       

          <ul>
  <li>
    <strong>Eliminates the need for explosives:</strong> 
    No blasting means no toxic gases, explosive residues, or chemical contamination of soil and water — reducing environmental hazards associated with explosive use.
  </li>

  <li>
    <strong>Reduces dust generation:</strong> 
    Controlled mechanical splitting produces far less airborne dust than blasting, improving air quality around the mine and reducing respiratory risks for workers and nearby communities.
  </li>

  <li>
    <strong>Minimizes ground vibration:</strong> 
    Because rock splitting uses hydraulic force rather than explosive impact, vibrations transmitted to the surrounding environment are significantly lower, protecting nearby ecosystems, infrastructure, and geological stability.
  </li>

  <li>
    <strong>Lowers noise pollution:</strong> 
    Hydraulic splitting operates with much lower noise levels compared to blasting, making it more suitable for mining near urban areas or sensitive habitats.
  </li>

  <li>
    <strong>Preserves surrounding ecosystems:</strong> 
    With reduced shock waves, debris scatter, and vibration, integrated rock-breaking systems limit environmental disturbance and help maintain ecological balance around mining sites.
  </li>

  <li>
    <strong>Better control over fragmentation:</strong> 
    Precision rock breakage reduces over-break and unnecessary waste, lowering energy and processing requirements for material handling and further crushing.
  </li>

  <li>
    <strong>Supports compliance with stricter environmental regulations:</strong> 
    Reduced emissions, lower noise, and minimal vibration help mining operations meet stringent environmental and community impact standards.
  </li>
</ul>

        </TextDiv>

      </ContentWrapper>

    </Wrapper>
  );
};

export default IRDSSpecsEnvironmental;